import { DemoQuestion } from '../../types/questions';

// Демо-питання - 12 захоплюючих питань з перших 2 розділів
// Розроблені для демонстрації якості та привабливості повного курсу!
// Оновлена структура з індивідуальними поясненнями для кожного варіанта (expA, expB, expC, expD)
export const demoQuestions: DemoQuestion[] = [
  {
    id: 1,
    text: "Ваш смартфон розпізнає обличчя для розблокування. Який це тип ШІ?",
    options: [
      "Вузький ШІ — він створений для одного конкретного завдання",
      "Загальний ШІ — він може робити все, що вміють люди",
      "Супер-ШІ — він розумніший за людей у всьому",
      "Штучний загальний інтелект — він думає як людина"
    ],
    correct: 0,
    expA: "Саме так! Розпізнавання облич — це вузький ШІ, створений для одного конкретного завдання. Він не вміє писати вірші, водити машину чи замовляти піцу (хоча було б круто!) — він просто відмінно розпізнає обличчя! Тому тестування вузького ШІ відрізняється від тестування звичайного ПЗ. 📱✨",
    expB: "Неправильно — загального ШІ ще не існує! Ми досі над цим працюємо. Ваш телефон розумний, але він не складає симфонії та не вирішує проблеми світу — він просто розблоковується, побачивши ваше прекрасне обличчя! 😊",
    expC: "Занадто фантастично! Супер-ШІ — це теоретична концепція, він був би розумнішим за людей у всьому. Розпізнавання облич у вашому телефоні вражає, але він не планує захоплення світу — просто допомагає швидше зайти в Інстаграм! 🤖",
    expD: "Ні, це те саме, що загальний ШІ! AGI — святий Грааль досліджень ШІ, але ми до нього ще не дійшли. Ваш телефон просто розпізнає обличчя, він не думає як людина — хоча іноді мені здається, що він засуджує мою ранкову зачіску! 😅",
    points: 1,
    chapter: "Вступ до ШІ",
    difficulty: "K1"
  },
  {
    id: 2,
    text: "Який сценарій демонструє знаменитий 'Ефект ШІ' в дії?",
    options: [
      "ШІ скрізь забирає робочі місця у людей (дякую, роботи! 🤖)",
      "Шахові комп'ютери колись вважалися 'ШІ', а тепер ми називаємо їх 'просто алгоритмами'",
      "ШІ набуває самосвідомості як у фантастичних фільмах",
      "ШІ-системи стають дорожчими в міру того, як стають розумнішими"
    ],
    correct: 1,
    expA: "Неточно — заміщення робочих місць це не ефект ШІ! Це інша (і дуже реальна) проблема. Ефект ШІ стосується сприйняття, а не працевлаштування. Хоча розумію, чому ви так подумали — це теж ефект від ШІ! 💼",
    expB: "Саме так! Ефект ШІ — це коли вчорашній 'дивовижний ШІ' стає сьогоднішнім 'звичайним алгоритмом'. Шахові комп'ютери були революційним ШІ, а тепер це просто... шахові програми! Як смартфони перетворилися з 'магії' на 'ну де мій зарядний?' 🏆➡️💻",
    expC: "Занадто голлівудсько! Самосвідомий ШІ — це не ефект ШІ, це швидше 'ШІ-апокаліпсис'! Ефект ШІ набагато тонший — мова про те, як ми сприймаємо інтелект, а не про повстання роботів. 🎬",
    expD: "Не зовсім — ціноутворення це не ефект ШІ! Насправді ШІ часто дешевшає з часом (подивіться на свій телефон!). Ефект ШІ — це планки, що зсуваються, того, що ми вважаємо 'справжнім' ШІ. 💰",
    points: 1,
    chapter: "Вступ до ШІ",
    difficulty: "K1"
  },
  {
    id: 3,
    text: "Ви тестуєте чат-бота, який дає медичні поради. Що вас НАЙБІЛЬШЕ турбує?",
    options: [
      "Наскільки швидко він відповідає на питання (швидкість — це життя!)",
      "Чи має він зручний користувацький інтерфейс",
      "Чи дає він точні, неупереджені поради, які не нашкодять людям",
      "Скільки серверної пам'яті він споживає під час розмов"
    ],
    correct: 2,
    expA: "Швидкість важлива, але не НАЙВАЖЛИВІША! Швидка неправильна відповідь про здоров'я може бути небезпечною. Краще почекати 5 секунд точної поради, ніж отримати миттєву дезінформацію. Швидкість має значення, але безпека понад усе! ⚡",
    expB: "Інтерфейс важливий для користувацького досвіду, але не критичний для безпеки! Потворний інтерфейс, який дає правильні медичні поради, кращий за красивий, що радить ефірні олії при інфаркті. Краса не рятує життя! 🎨",
    expC: "Чудово! Медичний ШІ має бути точним і неупередженим — від цього залежать людські життя! Гарний інтерфейс не допоможе, якщо бот радить ефірні олії при серцевому нападі. Ось чому тестування ШІ виходить за межі функціонального — ми тестуємо безпеку, упередженість та етичні аспекти! 🏥⚕️",
    expD: "Пам'ять важлива для продуктивності, але це не головна проблема безпеки! Навіть якщо чат-бот споживає багато пам'яті, це проблема інфраструктури. Неправильна медична порада — проблема, що загрожує життю! 💾",
    points: 1,
    chapter: "Характеристики якості систем на основі ШІ",
    difficulty: "K1"
  },
  {
    id: 4,
    text: "ШІ-система найму постійно відхиляє кандидаток-жінок. У чому проблема?",
    options: [
      "Системі потрібні потужніші GPU для обробки заявок",
      "Система працює занадто повільно в години пік",
      "Користувацький інтерфейс бентежить HR-співробітників",
      "Система засвоїла упередження з історичних даних про найм"
    ],
    correct: 3,
    expA: "Залізо тут ні до чого! Більше GPU не виправлять упередження — вони просто прийматимуть упереджені рішення швидше! Це як купити швидшу машину, коли проблема в тому, що ви їдете не в той бік. 🚗💨",
    expB: "Швидкість — не проблема! Повільна, але справедлива система краща за швидку упереджену. Повільність можна виправити кращою інфраструктурою, а упередження вимагають кардинальних змін у даних та алгоритмах. ⏱️",
    expC: "Плутанина в інтерфейсі не пояснює систематичного відхилення кандидаток-жінок! Навіть якщо HR-співробітники заплутались, така закономірність вказує на алгоритмічну упередженість, а не на помилки користувачів. Проблеми інтерфейсу не створюють гендерної дискримінації. 🖥️",
    expD: "Точно! ШІ може засвоїти людські упередження з навчальних даних! Якщо минулий найм був упередженим, ШІ засвоює цю упередженість як папуга, що повторює погані анекдоти. Тому тестування справедливості критично важливе — ми не хочемо, щоб ШІ увічнював наші найгірші звички! 👩‍💼⚖️",
    points: 1,
    chapter: "Характеристики якості систем на основі ШІ",
    difficulty: "K2"
  },
  {
    id: 5,
    text: "Що принципово ускладнює тестування ШІ-систем порівняно з традиційним ПЗ?",
    options: [
      "ШІ-системи завжди потребують дорожчого заліза для роботи",
      "ШІ-системи ймовірнісні й можуть давати різні результати на однакові вхідні дані",
      "ШІ-системи складніше встановлювати та налаштовувати",
      "ШІ-системам потрібні спеціальні мови програмування"
    ],
    correct: 1,
    expA: "Вартість заліза — не головний виклик тестування! Так, ШІ може бути дорогим у роботі, але це ресурсна проблема, а не фундаментальний виклик тестування. Можна тестувати на менших наборах даних або в хмарі. 💰",
    expB: "Саме так! На відміну від передбачуваного традиційного ПЗ (як торговий автомат), ШІ ймовірнісний — він може давати різні (але правильні) відповіді щоразу! Тестування має справлятися з цією невизначеністю. Це як питати друга про ресторани — отримаєте різні відповіді залежно від настрою! 🎲",
    expC: "Складність встановлення не унікальна для ШІ! Багато традиційних корпоративних систем складні у встановленні. Справжній виклик — недетерміністична поведінка ШІ-моделей під час тестування. 🔧",
    expD: "Мови програмування — не основна проблема! Можна використовувати Python, R, Java чи багато інших для ШІ. Виклик у тому, що ШІ вивчає патерни, які ми не можемо передбачити, а не в мові програмування. 👨‍💻",
    points: 1,
    chapter: "Вступ до ШІ",
    difficulty: "K2"
  },
  {
    id: 6,
    text: "Ви тестуєте ШІ безпілотного автомобіля. Який сценарій ви ОБОВ'ЯЗКОВО включите?",
    options: [
      "Лише звичайна їзда в сонячний день досконалими дорогами",
      "Лише їзда автострадою зі сталою швидкістю",
      "Екстремальна погода, будівельні зони та надзвичайні ситуації",
      "Лише практика на парковці без перешкод"
    ],
    correct: 2,
    expA: "Занадто обмежено! Тестувати лише ідеальні умови — це як вчитися плавати в дитячому басейні, а потім стрибати в океан. Справжня їзда включає дощ, пішоходів і водіїв, які вважають поворотники опцією! ☀️",
    expB: "Недостатньо різноманітно! Їзда автострадою важлива, але машини мають справлятися з міськими вулицями, шкільними зонами та тим перехрестям, де GPS завжди плутається. Різноманітність — ключ до надійного ШІ! 🛣️",
    expC: "Саме так! Безпілотні автомобілі мають справлятися з УСІМ — дощем, снігом, будівництвом, надзвичайними ситуаціями та, ймовірно, літаючими пакетами з магазинів! Тестування лише 'щасливих' сценаріїв небезпечне. Справжнє тестування ШІ вимагає крайніх випадків, стресових сценаріїв і критично важливих для безпеки ситуацій! 🚗🌧️",
    expD: "Занадто безпечно! Парковки добрі для основ, але машини мають справлятися зі справжнім хаосом — пішоходами, що пишуть СМС на ходу, чи велосипедистами, що з'являються нізвідки. Починайте безпечно, але тестуйте хаос! 🅿️",
    points: 2,
    chapter: "Характеристики якості систем на основі ШІ",
    difficulty: "K3"
  },
  {
    id: 7,
    text: "ШІ-система ідеально працює під час тестування, але відмовляє в продакшні. Яка НАЙЙМОВІРНІША причина?",
    options: [
      "Продакшн-серверу потрібно більше RAM для обробки навантаження",
      "Користувачі не дотримуються інструкцій правильного використання",
      "З'єднання з базою даних налаштовані неправильно",
      "Реальний розподіл даних відрізняється від тестових даних"
    ],
    correct: 3,
    expA: "RAM може бути проблемою, але зазвичай це спричиняє проблеми продуктивності, а не системні збої. Якщо логіка ШІ працювала під час тестування, більше пам'яті не виправить фундаментальні проблеми розподілу даних. 🖥️",
    expB: "Помилки користувачів можливі, але якщо система працювала під час тестування з контрольованими користувачами, проблема швидше глибша. ШІ має бути достатньо стійким, щоб справлятися з певною варіативністю користувачів. Не звинувачуйте користувачів у першу чергу! 👥",
    expC: "Конфігурація БД може впливати на продуктивність, але якщо ШІ працював під час тестування, проблеми з базою даних проявлялися б по-іншому. Це більше схоже на проблему якості/розподілу даних. 🗄️",
    expD: "Саме так! Це класична проблема 'навчання проти реальності'! ШІ, навчений на ідеальних тестових даних, може стикатися з труднощами при роботі з брудними реальними даними. Це як вчитися водити у відеогрі, а потім намагатися їздити в справжньому трафіку — реальність б'є боляче! 📊➡️🌍",
    points: 2,
    chapter: "Характеристики якості систем на основі ШІ",
    difficulty: "K3"
  },
  {
    id: 8,
    text: "У чому КЛЮЧОВА різниця між машинним навчанням і традиційними підходами до програмування?",
    options: [
      "Традиційне програмування дотримується правил, які ми пишемо; МН вивчає патерни з даних",
      "МН завжди працює значно швидше традиційного програмування",
      "МН працює лише з числовими даними, традиційне програмування — з текстом",
      "МН потребує спеціального дорогого заліза, традиційне програмування — ні"
    ],
    correct: 0,
    expA: "Чудово! Традиційне програмування: ми пишемо правила (як рецепт). МН: показуємо приклади, ШІ знаходить патерни! Це як вчити дитину на прикладах проти покрокових інструкцій. Обидва підходи працюють, але МН знаходить патерни, про існування яких ми навіть не підозрювали! 🧠📚",
    expB: "Швидкість — не ключова різниця! МН може бути швидшим або повільнішим залежно від завдання. Іноді традиційні алгоритми швидші! Ключова різниця в ТОМУ, ЯК вони вирішують проблеми — правила проти вивчення патернів. ⚡",
    expC: "Типи даних — не ключова різниця! Обидва можуть працювати з текстом, числами, зображеннями тощо. МН відмінно справляється з текстом (як ця розмова!), а традиційне програмування прекрасно обробляє числа. 📊📝",
    expD: "Вимоги до заліза — не визначальний чинник! МН можна робити на ноутбуці чи навіть телефоні. Традиційне програмування теж може потребувати потужного заліза для складних застосунків. Справа в підході, а не в залізі! 💻",
    points: 1,
    chapter: "Вступ до ШІ",
    difficulty: "K1"
  },
  {
    id: 9,
    text: "Чому 'пояснюваність' стає юридичною вимогою для ШІ-систем?",
    options: [
      "Це змушує ШІ-системи обробляти дані значно швидше",
      "Це допомагає зрозуміти, ЧОМУ ШІ прийняв рішення, особливо для важливих виборів",
      "Це значно знижує вартість розробки ШІ",
      "Це змушує ШІ-системи виглядати більш професійно для користувачів"
    ],
    correct: 1,
    expA: "Швидкість — не мета пояснюваності! Насправді додавання пояснюваності може сповільнити системи, бо їм потрібно генерувати пояснення. Мета — розуміння, а не швидкість. ⚡",
    expB: "Саме так! Пояснюваність критично важлива для довіри, безпеки та відповідності законам! Якщо ШІ відмовляє вам у кредиті чи медичному лікуванні, ви заслуговуєте знати чому. 'Тому що чорна скринька так сказала' — недостатньо гарна відповідь — нам потрібно, щоб ШІ показував свою роботу, як у класі математики! 🤔💡",
    expC: "Зниження витрат — не головна мета! Пояснюваність часто збільшує витрати на розробку, бо додає складність. Але це варто того заради довіри та відповідності. Думайте про це як про страхування для вашого ШІ! 💰",
    expD: "Професійний вигляд — не головна причина! Пояснюваність стосується відповідності законам і довіри, а не косметики. Прозоре рішення важливіше за гарний інтерфейс, який приховує спосіб прийняття рішень. ✨",
    points: 1,
    chapter: "Характеристики якості систем на основі ШІ",
    difficulty: "K2"
  },
  {
    id: 10,
    text: "Який найбільший виклик при тестуванні ШІ-систем на справедливість для різних демографічних груп?",
    options: [
      "Тестування справедливості потребує спеціалізованого дорогого заліза",
      "ШІ-системи обробляють дані занадто швидко для моніторингу справедливості",
      "Визначення того, що означає 'справедливо', може бути суб'єктивним і залежати від контексту",
      "Більшість ШІ-систем занадто складні для тестування справедливості"
    ],
    correct: 2,
    expA: "Залізо — не головна проблема! Справедливість можна тестувати на звичайних комп'ютерах — це більше про статистичний аналіз, ніж про обчислювальну потужність. Справжній виклик — визначити, що означає справедливість! 💻",
    expB: "Швидкість обробки — не перешкода! Ми можемо логувати рішення та аналізувати їх пізніше. Швидкість насправді допомагає — більше точок даних для аналізу патернів справедливості! Виклик філософський, а не технічний. ⚡",
    expC: "Абсолютно! Справедливість — це не лише технічна проблема, це проблема людських цінностей! Те, що 'справедливо' при наймі, може відрізнятися від того, що 'справедливо' при кредитуванні. Це як попросити кімнату людей домовитися про начинку для піци — контекст має значення, і в кожного є думка! ⚖️🤝",
    expD: "Складність керована! У нас є статистичні інструменти та фреймворки для тестування справедливості. Справжній виклик не в складності системи, а в складності визначення самої справедливості. 🧮",
    points: 2,
    chapter: "Характеристики якості систем на основі ШІ",
    difficulty: "K3"
  },
  {
    id: 11,
    text: "ШІ-система рекомендацій створює 'бульбашки фільтрів', показуючи користувачам лише схожий контент. Яку проблему тестування ШІ це демонструє?",
    options: [
      "Ідеальну алгоритмічну оптимізацію під користувацькі вподобання",
      "Високопродуктивну обробку та доставку контенту",
      "Відмінний користувацький досвід через персоналізацію",
      "Непередбачену поведінку системи та етичні наслідки"
    ],
    correct: 3,
    expA: "Не ідеально, якщо створює проблеми! Так, алгоритм оптимізований під вподобання, але ідеальна оптимізація може призвести до непередбачених наслідків. Іноді 'ідеальне' може бути занадто! 🎯",
    expB: "Продуктивність — не проблема! Система ефективно доставляє контент, але самої продуктивності замало. Треба також розглядати ширший вплив на користувачів і суспільство. 🚀",
    expC: "Користувацький досвід може здаватися відмінним, але бульбашки фільтрів можуть фактично шкодити користувачам, обмежуючи їхнє знайомство з різноманітними точками зору. Іноді добрий UX має приховані витрати! 😊",
    expD: "Саме так! Бульбашки фільтрів показують, як ШІ може мати непередбачені наслідки! Хоча продуктивно, може обмежувати відкриття та посилювати упередження. Це як мати друга, який рекомендує лише бойовики, бо вам сподобався один — різноманітність — родзинка життя! 🔄📱",
    points: 2,
    chapter: "Характеристики якості систем на основі ШІ",
    difficulty: "K3"
  },
  {
    id: 12,
    text: "Яка кінцева мета професійного тестування ШІ?",
    options: [
      "Забезпечити безпечність, надійність і корисність ШІ-систем для користувачів",
      "Змусити ШІ-системи працювати якнайшвидше на будь-якому залізі",
      "Зробити ШІ-системи максимально складними та функціональними",
      "Забезпечити можливість розгортання ШІ-систем на мобільних пристроях"
    ],
    correct: 0,
    expA: "Чудово! Кінцева мета — створення ШІ, який безпечно та надійно допомагає людям! Швидкість і складність — приємні бонуси, але безпека та надійність йдуть першими. Це як будувати міст — він має бути безпечним, перш ніж стати гарним чи швидким для переходу! 🛡️✨",
    expB: "Швидкість важлива, але це не кінцева мета! Швидка система, яка дає неправильні відповіді, марна. Краще мати трохи повільнішу систему, якій можна довірити важливі рішення. 🏃‍♂️",
    expC: "Складність заради складності — не мета! Іноді простіше краще. Найкращий ШІ елегантно вирішує справжні проблеми, а не вражає. Роздуті функціональності можуть фактично погіршувати системи! 🔧",
    expD: "Мобільне розгортання корисне, але це лише один варіант розгортання! Кінцева мета ширша — забезпечити, щоб ШІ добре служив людству, чи то на мобільних пристроях, десктопах чи в хмарі. 📱",
    points: 1,
    chapter: "Вступ до ШІ",
    difficulty: "K1"
  }
];